import React, { useCallback } from "react";
import { Badge, Box, Button, Checkbox, Divider, Grid, List, ListItem, ListItemText } from "@mzc-pdc/ui";
import Typography from "@components_v2/typography/typography";
import { IconArchive, ImageEmpty } from "@mzc-cloudplex/icons";
import theme from "@styles/theme";
import convertToByte from "@cores/convertToByte";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import convertUtcToLocal from "@cores/convertUtcToLocal";

const ListCardView = ({ data, component, selected, type }) => {
    const { t } = useTranslation();

    return data?.length ? (
        <Grid container spacing={2.5} sx={{ marginTop: "2px", overflow: "scroll" }}>
            {data?.map((item, index) => (
                <>{React.cloneElement(component, { data: item, selected })}</>
            ))}
        </Grid>
    ) : (
        <Box
            sx={{
                display: `flex`,
                alignItems: `center`,
                justifyContent: `center`,
                width: `100%`,
                flex: `1`,
                paddingTop: "5%",
                paddingBottom: "5%",
            }}
        >
            <Box
                sx={{
                    display: `flex`,
                    flexDirection: `column`,
                    alignItems: `center`,
                    justifyContent: `center`,
                    width: `400px`,
                    height: `400px`,
                    textAlign: `center`,
                }}
            >
                <ImageEmpty width={76} height={70} />
                <Typography variant={`subtitle2`} component={"p"} gutterBottom sx={{ marginTop: `20px` }}>
                    {t(`No ${type} items yet.`)}
                </Typography>
                <Typography
                    variant={`body3bold`}
                    component={"p"}
                    sx={{
                        mt: 1,
                        color: theme.palette.secondary[600],
                    }}
                >
                    {t(`Add it using the “Add ${type}” button.`)}
                </Typography>
            </Box>
        </Box>
    );
};

export default ListCardView;
